import React, { useState } from 'react';
import { formatPoints } from '../../../utils/helper';

const timelineSteps = [
  { id: 1, title: 'Reward', description: 'Select your reward', status: 'done' },
  { id: 2, title: 'Timeline', description: 'Choose duration', status: 'done' },
  { id: 3, title: 'Points', description: 'Review points', status: 'active' },
  { id: 4, title: 'Activities', description: 'Choose activities', status: '' },
  { id: 5, title: 'Review', description: 'Confirm goals', status: '' },
  { id: 6, title: 'Track', description: 'Monitor progress', status: '' },
];


const initialPointsData = {
  required: 72000,
  current: 15000,
  needed: 57000,
  progress: '44%',
  progressFraction: '15,000 / 72,000 points',
  estimatedPoints: 7250,
  additionalPoints: 49750,
};

const PointsContent = ({ updateFormData, setActiveSection, formData }) => {
  const earnedPoints = localStorage.getItem("earnedValue")
  const Total_earning_month = localStorage.getItem("Total_earning_month")
  const [pointsData, setPointsData] = useState(formData?.RewardsDetails);
  const handleUpdate = () => {
    const formattedData = {
      need: pointsData?.totalpoint - earnedPoints,
    };
    updateFormData(formattedData);
    setActiveSection('activities_timeline');
  };

  const progressbar = pointsData?.totalpoint > 0
    ? `${Math.round(Math.min((earnedPoints / pointsData?.totalpoint) * 100, 100))}%`
    : '0%'
  const tiers = localStorage.getItem("customerTier")
  const need = pointsData?.totalpoint - earnedPoints
  const needAdditional = (pointsData?.totalpoint - earnedPoints) - (Total_earning_month * 3)
  return (
    <main>
      <div className="timeline">
        <div className="timeline-content">
          <div className="timeline-content-inner active" id="points_timeline">
            <div className="timeline-points">
              <div className="timeline-points-box">
                <div className="timeline-points-box-header">
                  <h4>Points Calculation</h4>
                </div>
                <div className="timeline-points-box-top">
                  <div className="timeline-points-box-top-grid">
                    <div className="timeline-points-box-top-box required">
                      <p>Required</p>
                      <h3>{formatPoints(pointsData?.totalpoint)}</h3>
                      <p>{tiers} tier</p>
                    </div>
                    <div className="timeline-points-box-top-box current">
                      <p>Current</p>
                      <h3>{formatPoints(earnedPoints)}</h3>
                      <p>Earned</p>
                    </div>
                    <div className="timeline-points-box-top-box needed">
                      <p>Needed</p>
                      <h3>{formatPoints(need)}</h3>
                      <p>To goal</p>
                    </div>
                  </div>
                </div>
                <div className="timeline-points-box-middle">
                  <div className="home-goals-middle-top">
                    <div className="home-goals-middle-top-left">Progress towards goal</div>
                    <div className="home-goals-middle-top-right" data-progress={20}>
                      {`${formatPoints(earnedPoints)} / ${formatPoints(pointsData?.totalpoint)} points`}
                    </div>
                  </div>
                  {/* <div className="home-goals-middle-bottom">
                    <div className="home-goals-progress-container">
                      <div
                        className="home-goals-progress-bar"
                        style={{ width: progressbar }}
                      ></div>
                    </div>
                  </div> */}
                  <div className="timeline-track-progress">
                    <div className="timeline-track-progress-container">
                      <div
                        className="timeline-track-progress-fill"
                        style={{ width: progressbar || '0%' }}
                      ></div>
                    </div>
                  </div>
                </div>
                <div className="timeline-points-box-bottom">
                  <h4>Estimated Points Growth</h4>
                  <p>
                    Based on your historical data, you'll earn {formatPoints(Total_earning_month * 3)} points in 3 months.
                  </p>
                  <span>Additional {formatPoints(needAdditional)} points needed</span>
                </div>
                <div className="mt-4">
                  <button
                    className="btn btn-gold btn-block"
                    onClick={handleUpdate}
                  >
                    Continue to Activities
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </main>
  );
};

export default PointsContent;